import {
  CANCEL_CREATE,
  CANCEL_DELETE,
  CLEAR_QUEUES,
  QUEUE_CREATE,
  QUEUE_DELETE,
} from "../actions/actions";
import {
  ProfilePermissionQueueState,
  PendingCreate,
  PendingDelete,
} from "../actions/types";

const initialState: ProfilePermissionQueueState = {
  pendingCreates: [],
  pendingDeletes: [],
};

function samePair(
  a: { optionId: any; actionId: any },
  b: { optionId: any; actionId: any },
) {
  return (
    Number(a.optionId) === Number(b.optionId) &&
    Number(a.actionId) === Number(b.actionId)
  );
}

export default function reducer(
  state = initialState,
  action: { type: string; payload?: any },
): ProfilePermissionQueueState {
  switch (action.type) {
    case QUEUE_CREATE: {
      const item: PendingCreate = action.payload;
      const filtered = state.pendingCreates.filter((x) => !samePair(x, item));
      return { ...state, pendingCreates: [...filtered, item] };
    }
    case CANCEL_CREATE: {
      const { optionId, actionId } = action.payload;
      const filtered = state.pendingCreates.filter(
        (x) => !samePair(x, { optionId, actionId }),
      );
      return { ...state, pendingCreates: filtered };
    }
    case QUEUE_DELETE: {
      const item: PendingDelete = action.payload;
      const filtered = state.pendingDeletes.filter((x) => !samePair(x, item));
      return { ...state, pendingDeletes: [...filtered, item] };
    }
    case CANCEL_DELETE: {
      const { optionId, actionId } = action.payload;
      const filtered = state.pendingDeletes.filter(
        (x) => !samePair(x, { optionId, actionId }),
      );
      return { ...state, pendingDeletes: filtered };
    }
    case CLEAR_QUEUES:
      return initialState;
    default:
      return state;
  }
}
